import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MailService } from 'src/app/services/mail.service';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {
  @Input() title = 'Contáctanos para más información';
  @Input() isEquipmentForm = false;
  @Input() isCourseForm = false;
  @Input() buttonText = 'Enviar';

  generalForm = this.formBuilder.group({
    name: this.formBuilder.control('', Validators.required),
    email: this.formBuilder.control('', Validators.required),
    phone: '',
    message: '',
    equipment: this.formBuilder.array([
      this.formBuilder.group({
        brand: '',
        model: '',
        technicalRequirements: ''
      })
    ]),
    courses: this.formBuilder.array([
      this.formBuilder.group({
        code: '',
        people: null,
        city: '',
        comments: ''
      })
    ])
  });

  secondFormSubtitle: string;

  constructor(
    private formBuilder: FormBuilder,
    private mail: MailService,
    private router: Router) { }

  get equipmentForms() {
    return this.generalForm.get('equipment') as FormArray;
  }

  get coursesForms() {
    return this.generalForm.get('courses') as FormArray;
  }

  ngOnInit(): void {
    if (this.isEquipmentForm) {
      this.secondFormSubtitle = 'Equipos de interés';
      this.buttonText = 'Cotizar';
    } else if (this.isCourseForm) {
      this.secondFormSubtitle = 'Cursos de interés';
      this.title = 'Cotiza tu curso';
      this.buttonText = 'Cotizar';
    }
  }

  addEquipment(): void {
    this.equipmentForms.push(this.formBuilder.group({
      brand: '',
      model: '',
      technicalRequirements: ''
    }));
  }

  addCourse(): void {
    this.coursesForms.push(this.formBuilder.group({
      code: '',
      people: null,
      city: '',
      comments: ''
    }));
  }

  sendForm() {
    const formValue = {...this.generalForm.value};
    const url = this.router.url;
    formValue.isCourses = this.isCourseForm;

    if (this.isEquipmentForm) {
      if (url.includes('venta')) {
        formValue.isEquipmentSell = true;
      } else if (url.includes('reparacion')) {
        formValue.isEquipmentRepair = true;
      }
    } else if (url.includes('seguridad')) {
      formValue.isSecurity = true;
    }

    this.mail.sendMail(formValue).subscribe((res) => {
      this.router.navigateByUrl('/gracias');
    }, () => {
      this.router.navigateByUrl('/error');
    });
  }
}
